import React from 'react';
import { useParams } from 'react-router-dom';
import { jobsData } from '../../data/sampleData';

const JobDetails = () => {
    const { id } = useParams();
    const job = jobsData.find(j => j.id === parseInt(id)) || jobsData[0];

    return (
        <div className="p-8 bg-gray-50 min-h-screen">
            {/* Header Section */}
            <div className="bg-white rounded-xl shadow-sm mb-6">
                <div className="p-6 border-b border-gray-100">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-5">
                            <img
                                src={job.logo}
                                alt={job.company}
                                className="w-16 h-16 rounded-lg"
                            />
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">{job.title}</h1>
                                <div className="flex items-center mt-2 space-x-4">
                                    <span className="text-gray-600">{job.company}</span>
                                    <span className="text-gray-300">•</span>
                                    <span className="text-gray-600">{job.location}</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4">
                            <button className="px-6 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-200">
                                Apply Now
                            </button>
                            <button className="p-2.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-100">
                    <div className="p-6">
                        <div className="text-sm font-medium text-gray-500">Department</div>
                        <div className="mt-2 text-base text-gray-900">{job.department}</div>
                    </div>
                    <div className="p-6">
                        <div className="text-sm font-medium text-gray-500">Experience</div>
                        <div className="mt-2 text-base text-gray-900">{job.experience}</div>
                    </div>
                    <div className="p-6">
                        <div className="text-sm font-medium text-gray-500">Work Type</div>
                        <div className="mt-2 text-base text-gray-900">{job.type}</div>
                    </div>
                    <div className="p-6">
                        <div className="text-sm font-medium text-gray-500">Salary Range</div>
                        <div className="mt-2 text-base text-gray-900">{job.salary}</div>
                    </div>
                </div>
            </div>

            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Main Content */}
                <div className="lg:col-span-2 space-y-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Job Description</h2>
                        <div className="prose max-w-none text-gray-600">
                            {job.description.split('\n').map((paragraph, index) => (
                                <p key={index} className="mb-4">{paragraph}</p>
                            ))}
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Requirements</h2>
                        <ul className="space-y-4">
                            {job.requirements.map((requirement, index) => (
                                <li key={index} className="flex items-start">
                                    <svg className="w-5 h-5 text-green-500 mt-1 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-gray-600">{requirement}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Sidebar */}
                <div className="space-y-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Benefits</h2>
                        <ul className="space-y-4">
                            {job.benefits.map((benefit, index) => (
                                <li key={index} className="flex items-start">
                                    <svg className="w-5 h-5 text-purple-500 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <span className="text-gray-600">{benefit}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="bg-purple-50 rounded-xl p-6">
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center space-x-2">
                                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                                <span className="text-sm font-medium text-green-800">Actively Recruiting</span>
                            </div>
                            <span className="text-sm text-gray-500">Posted {job.posted}</span>
                        </div>
                        <button className="w-full bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors duration-200 mb-4">
                            Apply for this Position
                        </button>
                        <p className="text-sm text-purple-700 text-center">
                            {job.applicants} people have applied
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobDetails; 